/**
 * Bolinha (cor + inicial) por plataforma. A chave é o `platform` do scope: um
 * scope **é** uma plataforma, então é ele que define a identidade visual.
 *
 * A chave era o `tenant` até 2026-08-26, quando medq e aristo viraram uma
 * plataforma só — um scope que atende duas BUs não tem tenant único para
 * colorir. A inicial é explícita, e não derivada da primeira letra, porque
 * `aristo-medq` e `admin-dashboard` começam com a mesma.
 */
export const PLATFORM_BADGES: Record<
  string,
  { color: string; initial: string }
> = {
  'aristo-medq': { color: 'bg-purple-500', initial: 'E' },
  'admin-dashboard': { color: 'bg-neutral-500', initial: 'A' },
  'user-dashboard': { color: 'bg-emerald-500', initial: 'C' },
  'pipefy-admin': { color: 'bg-amber-500', initial: 'P' },
  'primum-dashboard': { color: 'bg-sky-500', initial: 'D' },
};

/** Plataforma desconhecida não some da tela — só perde cor e inicial próprias. */
export const PLATFORM_FALLBACK_BADGE = {
  color: 'bg-neutral-400',
  initial: '?',
};

export function platformBadge(platform: string | null | undefined): {
  color: string;
  initial: string;
} {
  return (platform && PLATFORM_BADGES[platform]) || PLATFORM_FALLBACK_BADGE;
}
